import { render, staticRenderFns } from "./bdproduct4.vue?vue&type=template&id=3179c94c&scoped=true"
import script from "./bdproduct4.vue?vue&type=script&lang=js"
export * from "./bdproduct4.vue?vue&type=script&lang=js"
import style0 from "./bdproduct4.vue?vue&type=style&index=0&id=3179c94c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3179c94c",
  null
  
)

export default component.exports